// extracted by mini-css-extract-plugin
export default {"container":"Divider_container__YGRFG"};